import { defineComponent as _defineComponent } from 'vue'
import WizardStep from '../wizard/WizardStep.vue';
import { Device } from '@/models/device';
import { devicesService } from '@/services/devices.service';
import { computed, onMounted, ref } from 'vue';
import { isEmpty } from '@/utils/misc';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'EquipmentListSelectorWizardStep',
  props: {
    value: { default: () => [] },
    selectedTenantIds: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: Device[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: Device[], selectedTenantIds: number[] };





const devices = ref<Device[]>([]);
const loading = ref(false);

const { t, tc } = useI18n();

onMounted(() => {
  refreshDevices();
});

async function refreshDevices() {
  loading.value = true;
  try {
    devices.value = await devicesService.getDevicesFromTenants(
      props.selectedTenantIds,
    );
  } finally {
    loading.value = false;
  }
}

function onEnter(fromPreviousPage: boolean) {
  if (!fromPreviousPage) {
    return;
  }

  if (isEmpty(devices.value) || hasTenantsSelectionChanged.value) {
    selectedEquipment.value = [];
    refreshDevices();
  }
}

function getDeviceBaseModelName(deviceBaseModelId: string): string {
  return devicesService.store.getDeviceBaseModelName(deviceBaseModelId);
}

const hasTenantsSelectionChanged = computed(() => {
  if (isEmpty(selectedEquipment)) {
    return false;
  }
  return selectedEquipment.value
    .map((x) => x.tenantId)
    .some((tenantId) => !props.selectedTenantIds.includes(tenantId));
});

const selectedEquipment = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

return { __sfc: true,props, emit, devices, loading, t, tc, refreshDevices, onEnter, getDeviceBaseModelName, hasTenantsSelectionChanged, selectedEquipment, WizardStep, isEmpty }
}

})